class Dl3dViewerM extends HTMLElement {
    constructor() {
        super();
        this.arQuickLookLink = this.querySelector('a[rel="ar"]');
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.isAndroid = /android/i.test(navigator.userAgent);
        this.isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent) ||
            (navigator.maxTouchPoints > 2 && /Macintosh/.test(navigator.userAgent));
        
        // Check if in Shopify theme editor mode
        const isThemeEditor = window.Shopify && window.Shopify.designMode;
        
        // If PC (not mobile) and not in theme editor, redirect to home page
        if (!this.isAndroid && !this.isIOS && !isThemeEditor) {
            window.location.href = this.dataset.redirectUrl || '/';
            return;
        }
        
        this.openAR();
    }
    // Device detection

    // Get config from URL parameters
    getURLParams() {
        return {
            iosModel: this.dataset.iosModel,
            androidModel: this.dataset.androidModel,
            // Product title
            title: this.dataset.title,
            // Return link
            link: this.dataset.link,
            // Auto-trigger (default is true)
            auto: this.dataset.auto !== 'false'
        };
    }

    // iOS AR Quick Look (Use existing link with product image)
    openIOSAR() {
        const config = this.getURLParams();
        
        // Build iOS params (hash parameters)
        let iosParams = '#allowsContentScaling=0';
        if (window.location.hash && window.location.hash.includes('#applePayButtonType')) {
            iosParams = window.location.hash;
        }
        
        // Use the existing link from HTML (with product image)
        if (this.arQuickLookLink) {
            this.arQuickLookLink.href = config.iosModel + iosParams;
            this.arQuickLookLink.click();
        }
    }

    // Android Google Scene Viewer (Based on Sayduck implementation)
    openAndroidAR() {
        const config = this.getURLParams();
        
        // Build Android params
        let androidParams = '';
        if (config.title) {
            androidParams += '&title=' + encodeURIComponent(config.title);
        }
        if (config.link) {
            androidParams += '&link=' + encodeURIComponent(config.link);
        }
        
        const intentUrl = `intent://arvr.google.com/scene-viewer/1.1?file=${encodeURIComponent(config.androidModel)}&mode=ar_preferred${androidParams}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;end;`;
        
        // Update existing link and trigger
        if (this.arQuickLookLink) {
            this.arQuickLookLink.href = intentUrl;
            this.arQuickLookLink.download = 'product.glb';
            this.arQuickLookLink.click();
        }
    }

    // Main function: Open AR
    openAR() {
        if (this.isIOS) {
            this.openIOSAR();
        } else if (this.isAndroid) {
            this.openAndroidAR();
        }
    }
}

customElements.define('dl-3d-viewer-m', Dl3dViewerM);